import React, {useEffect, useState} from "react";
import {ClientVirtualServerSuspensionInfo} from "../types/suspensions";
import {getObservedSuspensions} from "../web/suspensions";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {actionCreators} from "../actions";

export const SuspendedVirtualServersList = () => {
  const [observedSuspensions, setObservedSuspensions] = useState<ReadonlyArray<ClientVirtualServerSuspensionInfo>>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const loadSuspensions = async () => {
    const suspensions = await getObservedSuspensions();
    setObservedSuspensions(suspensions);
    setLoading(false);
  }

  useEffect(() => {
    loadSuspensions();
  }, [])

  return <div>
    <h1 className='no-margin-top'>Suspensions</h1>
    {observedSuspensions.length === 0 && !loading ? "No suspensions have been observed" : observedSuspensions.map(clientGroup => <div key={clientGroup.code}>
        <h2>{clientGroup.code}</h2>
        {clientGroup.virtualServerIds.map(id => <div className="margin-top-1-em" key={id}>
            {id}
            <Link
              className='button no-margin-top margin-left-1-em suppress-link-styles'
              to={`/red-buttons/${id}`}
              onClick={() => dispatch(actionCreators.selectClient(clientGroup.code))}
              >
              Go to green button
            </Link>
          </div>
        )}
      </div>
    )}
  </div>

}
